<template>
  <div style="padding: 0 10px">
    <el-tabs v-model="activeName" type="card">
      <el-tab-pane v-for="item in comList" :key="item.name" :label="item.title" :name="item.name">
        <div style="border: 1px solid #E4E7ED;border-top: none; padding: 10px;border-radius: 0 0 6px 6px">
          <component :is="item.name" :name="item.name" v-if="activeName == item.name" :customsList="customsList" :compilationMethodList="compilationMethodList" :reasonList="reasonList"/>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import fbaShip from './fbaShip'
import largeBagShip from './largeBagShip'
import smallBagShip from './smallBagShip'
import { auditReasonList,customsPage,compilationMethodPage } from "@/apis/outStock";

export default {
  name: "InternationalInvoice", // 国际发货单列表
  components: {
    fbaShip,
    largeBagShip,
    smallBagShip
  },
  data() {
    return {
      activeName: fbaShip.name,
      customsList:[],
      compilationMethodList:[],
      forwarder:[],
      reasonList:[]
    }
  },
  computed: {
    comList: function () {
      return [fbaShip, largeBagShip, smallBagShip]
    }
  },
  mounted(){
      compilationMethodPage().then(({code,data})=>{
        if(code == 0){
          this.compilationMethodList = data
        }
      })
      customsPage().then(({code,data})=>{
        if(code == 0){
          this.customsList = data
        }
      })
      auditReasonList().then(({code,data})=>{
        if(code == 0){
          this.reasonList = data
        }
      })
  }
}
</script>

<style scoped>
::v-deep .el-tabs__header {
  margin-bottom: 0px !important;
}
</style>